import { message } from '@ezviz/ezd';
import FetchData from '@ezviz/FetchData';
import util from '../../utils/utils';
import intl from 'react-intl-universal';
import _ from 'lodash';
export const UPDATE_TAGSLOADING_STATUS = 'UPDATE_TAGSLOADING_STATUS';
export const FETCH_TAGS_DATA_LIST = 'FETCH_TAGS_DATA_LIST';
export const GET_TAGSBLACKLISTNULL_LIST = 'GET_TAGSBLACKLISTNULL_LIST';

/**
 * 修改页面加载loading
 * @param {*} param
 */
export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_TAGSLOADING_STATUS,
      loading
    });
  };
}

/**
 * 获取标签数据列表
 * @param {*} param
 */
export function fetchTagsList(param, callback) {
  return (dispatch, getState) => {
    const defaultParam = {
      pageStart: 0,
      pageSize: 10,
    }
    const req = Object.assign({}, defaultParam, param);
    dispatch(updateLoadingStatus(true));
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/v3/tag/page`, {
      method: 'POST',
      body: req,
    });

    fetchData.then((res) => {
      dispatch(updateLoadingStatus(false));
      if (res.code == 200) {
        let list = _.get(res, 'data', []);
        const total = _.get(res, 'page.total', 0);
        if (!!callback) {
          callback(list);
        } else {
          // 判断未搜索时，是否有数据
          if (!param.name || param.name == '') {
            dispatch({
              type: GET_TAGSBLACKLISTNULL_LIST,
              isDataList: list.length > 0,
            });
          }
          dispatch({
            type: FETCH_TAGS_DATA_LIST,
            dataList: list,
            total: total,
          });
        }
      } else {
        message.error(intl.get('commmon.operate.retry'));
        callback && callback()
      }
    }).catch(e => {
      console.log("查询标签接口错误", e);
      dispatch(updateLoadingStatus(false));
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}

/**
 * 新增
 * @param {*} param
 */
export function addTags(param, callback, failback) {
  return (dispatch, getState) => {
    fetchFun('/api/iot/support/v3/tag/add', 'POST', param, callback, failback)
  };
}

/**
 * 修改
 * @param {*} param
 */
export function editTags(param, callback, failback) {
  return (dispatch, getState) => {
    fetchFun('/api/iot/support/v3/tag/update', 'PUT', param, callback, failback)
  };
}


/**
 * 删除
 * @param {*} param
 */
export function deleteTags(param, callback, failback) {
  return (dispatch, getState) => {
    fetchFun('/api/iot/support/v3/tag/delete', 'DELETE', param, callback, failback)
  };
}


/**
 * 封装接口函数
 * @param {*} param
 */
function fetchFun(url, method, param, callback, failback) {
  const defaultParam = {}
  const req = Object.assign({}, defaultParam, param);
  const fetchData = new FetchData(`${util.requestPath}${url}`, {
    method: method,
    headers: { 'Content-Type': 'application/json' },
    body: req,
  });
  fetchData.then((res) => {
    if (res.code == 200) {
      callback && callback(res.data || {});
    } else if (res.code == "50020") {
      failback && failback();
      message.error(intl.get('commmon.operate.upgradeing'));
    } else {
      failback && failback();
      message.error(res.msg || intl.get('commmon.operate.retry'));
    }
  }).catch(e => {
    failback && failback();
    message.error(intl.get('commmon.operate.retry'));
  })
}
